import React from 'react'
import styled, { css } from 'styled-components'

import Button from 'components/presenters/button/Button'
import CheckBox from 'components/presenters/button/CheckBox'
import SVGIcon from 'components/modules/common/SVGIcon/SVGIcon'

export default function AccountFormModal({
  accountHolderName,
  accountNumber,
  errors,
  privacyConsentError,
  updated,
  isPrivacyConsent,
  onClose,
  onChange,
  onSubmit,
  onPrivacyConsent,
  onOpenPrivacyConsent,
  onToggleAccountNumberVisibility,
  accountNumberVisible,
}) {
  return (
    <FullScreen>
      <WhiteBox>
        <CloseBtnBlock onClick={onClose}>
          <SVGIcon name="close" />
        </CloseBtnBlock>
        <TitleBlock>
          <Title>{`리워드 관련\n추가정보가 필요해요`}</Title>
        </TitleBlock>
        <DescriptionBlock>
          <Description>
            {`챌린지 상금을 받기 위해서는\n회원님의 이름, `}
            <DescriptionBoldTxt>신한은행</DescriptionBoldTxt>
            {` 계좌번호가\n필요합니다.`}
          </Description>
        </DescriptionBlock>
        <FormFields autoComplete="off">
          <InputBlock>
            <InputLabel>{`이름 (예금주)`}</InputLabel>
            <InputArea
              isError={errors.accountHolderName && updated.accountHolderName ? true : false}
            >
              <Input
                value={accountHolderName}
                name={'accountHolderName'}
                onChange={onChange}
                placeholder={`홍길동`}
                required
              />
            </InputArea>
            {errors.accountHolderName && updated.accountHolderName && (
              <ErrorMessage>{errors.accountHolderName}</ErrorMessage>
            )}
          </InputBlock>
          <InputBlock>
            <InputLabel>{`신한 계좌번호`}</InputLabel>
            <InputArea isError={errors.accountNumber && updated.accountNumber ? true : false}>
              <Input
                type={accountNumberVisible ? 'text' : 'password'}
                inputMode="numeric"
                pattern="[0-9]*"
                value={accountNumber ? accountNumber : ''}
                name={'accountNumber'}
                onChange={onChange}
                placeholder={`'-'없이 숫자만 입력`}
                required
              />
              <EyeIconBlock
                onClick={onToggleAccountNumberVisibility}
                isVisible={accountNumberVisible}
              >
                <SVGIcon name={accountNumberVisible ? 'unseeEye' : 'seeEye'} />
              </EyeIconBlock>
            </InputArea>
            {errors.accountNumber && updated.accountNumber && (
              <ErrorMessage>{errors.accountNumber}</ErrorMessage>
            )}
          </InputBlock>
        </FormFields>
        <input type="checkbox" style={{}} />
        <CheckBoxBlock>
          <CheckForm>
            <CheckLabel>
              <CheckBox checked={isPrivacyConsent} onChange={onPrivacyConsent} />
            </CheckLabel>
            <CheckDescription onClick={onOpenPrivacyConsent}>
              (필수)개인정보에 제3자 제공에 대한 안내에 동의합니다
            </CheckDescription>
          </CheckForm>
          {privacyConsentError && <ErrorMessage>{privacyConsentError}</ErrorMessage>}
        </CheckBoxBlock>

        <PrecautionsBlock>
          <Precautions>{`*신한금융투자 계좌는 상금 지급이 불가합니다`}</Precautions>
          <Precautions>{`*이름과 신한 계좌번호가 다를경우, 상금 수령 불가`}</Precautions>
        </PrecautionsBlock>

        <BottomButtonBlock>
          <SubmitButton onClick={onSubmit} fullwidth>
            확인
          </SubmitButton>
        </BottomButtonBlock>
      </WhiteBox>
    </FullScreen>
  )
}

const FullScreen = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 400;
`

const WhiteBox = styled.div`
  position: relative;
  background-color: #ffffff;
  width: calc(100vw * (280 / 375));
  border-radius: calc(100vw * (9 / 375));
  padding: calc(100vw * (42 / 375)) calc(100vw * (20 / 375)) calc(100vw * (24 / 375))
    calc(100vw * (20 / 375));
`

const CloseBtnBlock = styled.div`
  position: absolute;
  top: calc(100vw * (17 / 375));
  left: calc(100vw * (17 / 375));
  width: calc(100vw * (14 / 375));
  height: calc(100vw * (14 / 375));

  > svg {
    color: #4e4e4e;
  }
`

const TitleBlock = styled.div`
  margin-bottom: calc(100vw * (15 / 375));
`

const Title = styled.h1`
  font-size: calc(100vw * (18 / 375));
  font-weight: 700;
  line-height: calc(100vw * (24 / 375));
  text-align: center;
  color: #121212;
  white-space: pre-wrap;
`

const DescriptionBlock = styled.div`
  margin-bottom: calc(100vw * (23 / 375));
`

const Description = styled.p`
  font-size: calc(100vw * (14 / 375));
  font-weight: 400;
  line-height: calc(100vw * (20 / 375));
  text-align: center;
  color: #4e4e4e;
  white-space: pre-wrap;
`
const DescriptionBoldTxt = styled.span`
  font-weight: bold;
`

const FormFields = styled.form``

const InputBlock = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: calc(100vw * (17 / 375));
  &:last-child {
    margin-bottom: 0;
  }
`

const InputLabel = styled.label`
  font-size: calc(100vw * (14 / 375));
  font-weight: 500;
  line-height: calc(100vw * (20 / 375));
  margin-bottom: calc(100vw * (8 / 375));
`

const InputArea = styled.div`
  display: flex;
  align-items: center;
  border: 1px solid #d5d5d5;
  border-radius: calc(100vw * (5 / 375));
  width: 100%;
  overflow: hidden;
  ${(props) =>
    props.isError &&
    css`
      border: 1px solid #de0000;
    `}
`

const Input = styled.input`
  font-size: calc(100vw * (14 / 375));
  font-weight: 400;
  line-height: calc(100vw * (20 / 375));
  padding: calc(100vw * (12 / 375)) calc(100vw * (7.8 / 375));
  width: 100%;

  &::placeholder {
    color: #c6c6c6;
  }
`

const EyeIconBlock = styled.div`
  width: calc(100vw * (21 / 375));
  height: calc(100vw * (21 / 375));
  margin: calc(100vw * (12 / 375));

  svg {
    color: #c4c4c4;

    ${({ isVisible }) =>
      isVisible &&
      css`
        color: #7f7f7f;
      `}
  }
`

const ErrorMessage = styled.span`
  font-size: calc(100vw * (11 / 375));
  font-weight: 400;
  line-height: calc(100vw * (15.5 / 375));
  color: #de0000;
  margin-top: calc(100vw * (5 / 375));
`

const CheckBoxBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: calc(100vw * (14 / 375));
  margin-top: calc(100vw * (8 / 375));
  padding-right: calc(100vw * (20 / 375));
`

const CheckForm = styled.div`
  display: flex;
`

const CheckLabel = styled.label``

const CheckDescription = styled.span`
  font-size: calc(100vw * (11 / 375));
  font-weight: 400;
  line-height: calc(100vw * (15.07 / 375));
  color: #4e4e4e;
  text-decoration: underline;
`

const PrecautionsBlock = styled.div`
  margin-bottom: calc(100vw * (8 / 375));
`

const Precautions = styled.p`
  font-size: calc(100vw * (11 / 375));
  font-weight: 400;
  line-height: calc(100vw * (15.5 / 375));
  color: #7f7f7f;
  text-align: left;
  padding-left: calc(100vw * (9 / 375));
`

const BottomButtonBlock = styled.div``

const SubmitButton = styled(Button)`
  font-size: calc(100vw * (16 / 375));
  font-weight: 500;
  line-height: calc(100vw * (24 / 375));
  border-radius: calc(100vw * (8 / 375));
  background-color: #ffcf19;
  padding: calc(100vw * (14 / 375)) 0;
`
